import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Tax Roll Adjustment';

export const TaxRollAdjustmentRoutes = [
  {
    path: '/tax/adjustments',
    name: 'Tax-tax Roll Adjustment',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/TaxRollAdjustments.vue'),
    children: [
      {
        path: 'reports',
        name: 'Tax -Tax Roll Adjustment Report',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/TaxRollAdjustments/Reports.vue'),
      },
    ],
  },
];

TaxRollAdjustmentRoutes.forEach((element, index) => {
  TaxRollAdjustmentRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria([...authRoles.TaxRead, ...authRoles.AjustmentAuth], next);
  };
});

export default TaxRollAdjustmentRoutes;
